var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-width":"1500px","overflow-y":"auto"}},[_c('div',{attrs:{"id":"app"}},[_c('router-view')],1),(_vm.$route.name !== 'login')?_c('FooterVue'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }